import type {TemplateListPaneQueryQuery} from '@github-ui/server-persisted-queries/types/TemplateListPaneQuery'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

import type {RepositoryNode} from './template-list-query-types'

export type TemplateListData = RepositoryNode

export function templateListQueryKey(owner: string, repo: string) {
  return ['issue-create', 'template-list', {owner, repo}] as const
}

export async function fetchTemplateList(owner: string, repo: string, signal?: AbortSignal): Promise<TemplateListData> {
  const response = await verifiedFetchJSON(`/${owner}/${repo}/issues/new/template_list`, {signal})
  if (!response.ok) {
    throw new Error(`Template list fetch failed (${response.status})`)
  }

  const json = (await response.json()) as {data?: TemplateListPaneQueryQuery; errors?: unknown[]}
  if (json.errors?.length || !json.data) {
    throw new Error('Template list query returned errors')
  }

  const node = json.data.node
  if (!node || node.__typename !== 'Repository') {
    throw new Error('Template list query returned unexpected node type')
  }

  return node
}
